import { EboObjectTO } from '../base-classes/ebo-object-to';
import { Hub } from '../places/hub/hub';
import { Route } from './route';

export class RouteHub extends EboObjectTO {
  hubId: number;
  hub: Hub;
  routeId: string;
  route: Route;

  constructor(jsonData: Partial<RouteHub>) {
    super(jsonData);
    if (jsonData.hub) this.hub = new Hub(jsonData.hub);
    if (jsonData.route) this.route = new Route(jsonData.route);
  }

  toShortString(format: string): string {
    if (format == 'hubToShortString') {
      return this.hub ? this.hub.toShortString() : null;
    }
    return null;
  }
}
